z<template>
	<div class="vx-row">        

		<!-- MULTIPLE COLUMNS-->
		<div class="vx-col w-full mb-base">            

			<vx-card title="Edit Company details">
                <router-link to="/company/lists"><vs-button color="primary" type="filled" >List</vs-button></router-link>
                <!-- <h4 class="text-success text-center">{{ successTxt }}</h4>
                <h4 class="text-danger text-center">{{ errorTxt }}</h4> -->
                <form @submit.prevent="submitForm">

                    <div class="vx-row">
                        <div class="vx-col sm:w-1/3 w-full mb-3">
                            <vs-input class="w-full" label-placeholder="Company Name" v-model="CompanyName" v-validate="'required'" name="CompanyName" :readonly="true" />
                            <span class="text-danger text-sm" v-show="errors.has('CompanyName')">{{ errors.first('CompanyName') }}</span>
                        </div>

                        <div class="vx-col sm:w-1/3 w-full mb-3">
                            <vs-input class="w-full" label-placeholder="Gst Number" v-model="GstNumber" v-validate="'min:15'" name="GstNumber" :maxlength="15" />
                            <span class="text-danger text-sm" v-show="errors.has('GstNumber')">{{ errors.first('GstNumber') }}</span>
                        </div>

                        <div class="vx-col sm:w-1/3 w-full mb-3">
                            <vs-input class="w-full" label-placeholder="Pan Number" v-model="PanNumber" v-validate="'min:10'" :maxlength="10" name="PanNumber" />
                            <span class="text-danger text-sm" v-show="errors.has('PanNumber')">{{ errors.first('PanNumber') }}</span>
                        </div>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col w-full mb-3">
                            <vs-input class="w-full" label-placeholder="Address" v-model="Address" v-validate="'required'" name="Address" />
                            <span class="text-danger text-sm" v-show="errors.has('Address')">{{ errors.first('Address') }}</span>
                        </div>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col sm:w-1/3 w-full mb-3">
                            <span class="text-primary text-sm vs-placeholder-label"> City Code </span>
                            <v-select v-model="CityCode" name="CityCode" :value="CityCode" :options="CityCodeOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                            <span class="text-danger text-sm" v-show="errors.has('CityCode')">{{ errors.first('CityCode') }}</span>
                        </div>

                        <div class="vx-col sm:w-1/3 w-full mb-3">
                            <vs-input class="w-full" label-placeholder="Contact Number" v-model="ContactNumber" v-validate="'required'" name="ContactNumber" />
                            <span class="text-danger text-sm" v-show="errors.has('ContactNumber')">{{ errors.first('ContactNumber') }}</span>
                        </div>

                        <div class="vx-col sm:w-1/3 w-full mb-3">
                            <vs-input class="w-full" label-placeholder="Landline Number" v-model="LandlineNumber" v-validate="''" name="LandlineNumber" />
                            <span class="text-danger text-sm" v-show="errors.has('LandlineNumber')">{{ errors.first('LandlineNumber') }}</span>
                        </div>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col sm:w-1/3 w-full mb-3">
                            <!-- <vs-input class="w-full" label-placeholder="Logo" v-model="Logo" v-validate="''" name="Logo" /> -->
                            <h4>Select Logo</h4>
                            <input type="file" ref="file" >
                            <span class="text-danger text-sm" v-show="errors.has('Logo')">{{ errors.first('Logo') }}</span>
                        </div>

                        <div class="vx-col sm:w-1/3 w-full mb-3">
                            <vs-input class="w-full" label-placeholder="Website" v-model="Website" v-validate="''" name="Website" />
                            <span class="text-danger text-sm" v-show="errors.has('Website')">{{ errors.first('Website') }}</span>
                        </div>

                        <div class="vx-col sm:w-1/3 w-full mb-3">
                            <vs-input class="w-full" label-placeholder="Email" v-model="Email" v-validate="''" name="Email" />
                            <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
                        </div>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col sm:w-1/3 w-full mb-3">
                            <span class="text-primary text-sm vs-placeholder-label"> Active Status </span>
                            <v-select v-model="ActiveStatus" name="ActiveStatus" :value="ActiveStatus" :options="ActiveStatusOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                            <span class="text-danger text-sm" v-show="errors.has('ActiveStatus')">{{ errors.first('ActiveStatus') }}</span>
                        </div>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <vs-button type="filled" @click.prevent="submitForm" class="mr-3 mb-2">Submit</vs-button>
                            <!-- <vs-button color="warning" type="border" class="mb-2" @click.prevent="getData">Reset</vs-button> -->
                        </div>
                    </div>
                </form>
			</vx-card>
		</div>
	</div>
</template>

<script>

import companyConfig from '@/company_config.json'
import common from '@/views/Common.vue'
import { Validator } from 'vee-validate';
import vSelect from 'vue-select'

const dict = {
  custom: {
    CompanyName: { required: 'Company Name should not be empty' },
    Address: { required: 'Address should not be empty' },
    CityCode: {
        required: 'City Code should not be empty',
        numeric: 'Enter valid City Code', 
    },
    GstNumber: {
        min: 'Gst Number should contain 15 characters', 
    },
    PanNumber: {
        min: 'Pan Number should contain 10 characters', 
    },
    ContactNumber: { required: 'Contact Number should not be empty' },
    LandlineNumber: { required: 'Landline Number should not be empty' },
    Logo: { required: 'Logo should not be empty' },
    Website: { required: 'Website should not be empty' },
    Email: { required: 'Email should not be empty' },
    ActiveStatus: { required: 'Active Status should not be empty' },
  }
};

// register custom messages
Validator.localize('en', dict);

export default{
    mixins: [common],
    components: {
        'v-select': vSelect,
    },
	data() {
		return {
            successTxt: '',
            errorTxt: '',
            CompanyName : '',
            Address : '',
            CityCode : 1,
            GstNumber : '',
            PanNumber : '',
            ContactNumber : '',
            LandlineNumber : '',
            Logo : '',
            Website : '',
            Email : '',
            ActiveStatus : '',
            CityCodeOptions: [],
            ActiveStatusOptions: this.selectListActiveStatus(),

            LogoImage: ''
		}
    },
    methods: {
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            this.createImage(files[0]);
        },
        createImage(file) {
            var image = new Image();
            var reader = new FileReader();
            var vm = this;

            reader.onload = (e) => {
                vm.LogoImage = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        removeImage: function (e) {
            this.LogoImage = '';
        },
        backPage() {
            this.$router.go(-1);
        },
        resetFormData() {
            this.successTxt = ''
            this.errorTxt = ''
            this.categoryId = ''
            this.groupId = ''
            this.ledgerName = ''
            this.openingBalance = ''
        },
        submitForm() {
            this.$validator.validateAll().then(result => {
                if(result) {
                    // if form have no errors
                    // alert("form submitted!");
                    // this.resetFormData()
                    var url='lib/api/company/update';
                    console.log('url='+url);

                    var id=this.$route.query.id;
                    console.log('id=' +this.$route.query.id);
                    /*
                    var formData = [
                        'CompanyName', 
                        'Address', 
                        'CityCode', 
                        'GstNumber', 
                        'PanNumber', 
                        'ContactNumber', 
                        'LandlineNumber', 
                        'Logo', 
                        'Website', 
                        'Email', 
                        'ActiveStatus', 
                    ]
                    */
                    var where = {
                        'CompanyId': id,
                    };

                    var redirect_url='/company/edit';
                    var params={
                        'CompanyId': id,
                    };
                    console.log('params='+JSON.stringify(params)+', redirect_url='+redirect_url);

                    // this.updateRecords(where, formData, url, redirect_url, params);

                    var record = {}

                    var recordObj = {
                        'CompanyName' : this.CompanyName, 
                        'Address' : this.Address, 
                        'CityCode' : this.CityCode, 
                        'GstNumber' : this.GstNumber, 
                        'PanNumber' : this.PanNumber, 
                        'ContactNumber' : this.ContactNumber, 
                        'LandlineNumber' : this.LandlineNumber, 
                        'Logo' : this.LogoImage, 
                        'Website' : this.Website, 
                        'Email' : this.Email, 
                        'ActiveStatus' : this.ActiveStatus, 
                    };

                    var server_url=companyConfig.apiURL;
                    record.token=this.$session.get('token');
                    record.update_url=server_url+'lib/api/company/update';
                    record.where={
                        'CompanyId': id,
                    };
                    record.form=recordObj;
                    record.list_url=server_url+'lib/api/ledgers/ledger/ledger/lists';
                    record.list_where={
                        "LedgerGroup": 4,
                        "where": {}
                    };
                    console.log('record='+JSON.stringify(record));

                    this.LogoImage = this.$refs.file.files[0];

                    let formData = new FormData();
                    formData.append('token',record.token);
                    formData.append('CompanyId',this.CompanyId);
                    formData.append('CompanyName',this.CompanyName);
                    formData.append('Address',this.Address);
                    formData.append('CityCode',this.CityCode);
                    formData.append('GstNumber',this.GstNumber);
                    formData.append('PanNumber',this.PanNumber);
                    formData.append('ContactNumber',this.ContactNumber);
                    formData.append('LandlineNumber',this.LandlineNumber);
                    formData.append('Logo', this.LogoImage);
                    formData.append('Website',this.Website);
                    formData.append('Email',this.Email);
                    formData.append('ActiveStatus',this.ActiveStatus);

                    var upload = {
                        'token': record.token,
                        'where': record.where,
                        'form': recordObj
                    };                    
                    // this.$store.dispatch('ledger/updateRecordDetails', this.record);
                    
                    this.pageLoadingOn();
                    const thisIns = this;
                    this.$http({
                        url: record.update_url,
                        method: 'POST',
                        data: formData,
                        headers: {
                        'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(function (response) {
                        console.log('response='+JSON.stringify(response));
                        var output = response.data.output;
                        var flag = response.data.flag;
                        console.log('output='+output+', flag='+flag);
                        var successTxt = response.data.success;
                        var errorTxt = response.data.error;
                        console.log('successTxt='+successTxt+', errorTxt='+errorTxt);
                        
                        thisIns.pageLoadingOff();
                        if (flag == 1) {

                        thisIns.successMessage(successTxt);              
                            thisIns.pageRedirect(params, redirect_url);

                        }else{
                            thisIns.errorMessage(errorTxt);
                        }

                    })
                    .catch(function (error) {
                        console.log('error='+error);
                    })                    
                    
                }else{
                    // form have errors
                }
            })
        },
                
    },
    beforeCreate: function () {    
        if (!this.$session.exists()) {
        console.log('your session is expired');
        this.$router.push('/');
        }    
    },
    beforeMount() {
        if (!this.$session.exists()) {
            console.log('your session is expired');
            this.$router.push('/');      
        }else{

            var selectbox1_source = 'CityCode'
            var selectbox1_destination = 'CityCodeOptions'
            var selectbox1_url = 'lib/api/data/get_city_options'
            var selectbox1_conditions_array = {
                'city_details_district_details_id >=': 1
            }
            this.getSelectBoxOptions(selectbox1_source, selectbox1_destination, selectbox1_conditions_array, selectbox1_url)

            var id=this.$route.query.id;
            console.log('id=' +this.$route.query.id);

            var url='lib/api/company/get_data';
            var where = {
                'company_info_id': id,
            };
            var destinations = [
                'CompanyName', 
                'Address', 
                'CityCode', 
                'GstNumber', 
                'PanNumber', 
                'ContactNumber', 
                'LandlineNumber', 
                'Logo', 
                'Website', 
                'Email', 
                'ActiveStatus', 
            ];
            console.log('url='+url);
            this.getRecords(where, destinations, url);
        }
    },
}
</script>

<style>
.company-logo {
    width: 200px;
    height: 100px;
}
</style>